import Vue from 'vue'
import Router from 'vue-router'
import Home from "@/components/Home/Home"
import Hello from '@/components/Hello'
import CourseDetails from '@/components/CourseDetails/CourseDetails'
import order from "@/components/order/order"
import audit from "@/components/audit/audit"
import orderList from "@/components/orderList/orderList"
//import store from "../store/store"
import orderDetail from "@/components/orderDetail/orderDetail"
import PaymentOrder from "@/components/PaymentOrder/PaymentOrder"
import courseList from "@/components/courseList/courseCen"
import paymentQR from "@/components/paymentQR"
import ApplyInvoice from "@/components/ApplyInvoice/ApplyInvoice"
import AboutEnoch from "@/components/AboutEnoch/AboutEnoch"
import PaySuccess from "@/components/PaymentOrder/PaySuccess"
import scholarship from "@/components/orderList/scholarship"
import Myorder from "@/components/orderList/Myorder"
import Mycoupons from "@/components/orderList/Mycoupons"
import MyBalance from "@/components/orderList/MyBalance"
import Invite from "@/components/orderList/Invite"
Vue.use(Router)


 const routes= [
    {
      path: '/',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/courseList',
      name: 'courseList',
      component: courseList
    },
    {
    	path: '/CourseDetails/:id',
      name: 'CourseDetails',
      component: CourseDetails
    },
    {
    	path: '/order/:id',
      name: 'order',
      meta:{
      	auth:true
      },
      component: order
    },
    {
    	path: '/audit',
      name: 'audit',
       meta:{
      	auth:true
      },
      component: audit
    },
    {
    path: '/orderList',
      name: 'orderList',
      meta:{
      	auth:true
      },
      component: orderList,
      redirect:{name:"Myorder"},
      children:[
        {
      path: '/Myorder',
      name: 'Myorder',
      meta:{
      	auth:true
      },
      component: Myorder
   		},
      	{
      path: '/scholarship',
      name: 'scholarship',
      meta:{
      	auth:true
      },
      component: scholarship
   		},
   		{
      path: '/Mycoupons',
      name: 'Mycoupons',
      meta:{
      	auth:true
      },
      component: Mycoupons
   		},
   		{
      path: '/MyBalance',
      name: 'MyBalance',
      meta:{
      	auth:true
      },
      component: MyBalance
   		},
// 		{
//    path: '/Invite',
//    name: 'Invite',
//    meta:{
//    	auth:true
//    },
//    component: Invite
// 		},
      ]
    },
    {
    path: '/orderDetail/:id',
      name: 'orderDetail',
      meta:{
      	auth:true
      },
      component: orderDetail
    },
    {
    path: '/PaymentOrder/:id',
      name: 'PaymentOrder',
//    meta:{
//    	auth:true
//    },
      component: PaymentOrder
    },
    {
    path: '/paymentQR/:id',
      name: 'paymentQR',
      meta:{
      	auth:true
      },
      component: paymentQR
    },
   {
      path: '/ApplyInvoice/:id',
      name: 'ApplyInvoice',
      meta:{
      	auth:true
      },
      component: ApplyInvoice
   },
   {
    path: '/',
      name: 'Home',
      component: Home
    },
   {
      path: '/AboutEnoch',
      name: 'AboutEnoch',
      component: AboutEnoch
   },
   {
      path: '/PaySuccess/:id',
      name: 'PaySuccess',
      meta:{
      	auth:true
      },
      component: PaySuccess
   },
   
  ]


 let router = new Router({routes:routes,mode:'history'});

const token=localStorage.getItem('token')
router.beforeEach((to,from,next)=>{
 if(to.meta.auth){
   if(token){
    next();
   }else{
//如果判断没有token，跳转到登录页面
$(".backdrop").css({"display":"block"})
next();
   }
 }else{
   next();
 }
if(from.name) {  
    _hmt.push(['_trackPageview'  
      , '/#' + to.fullPath  
      , window.location.origin ]);  
  } else {  
    _hmt.push(['_trackPageview'  
        , '/#' + to.fullPath]);  
  }    
 });

export default router



// WEBPACK FOOTER //
// ./src/router/index.js